const SEGMENT_GROSS_REVENUE = '1';
const SEGMENT_NET_PROFIT = '2';

const SEGMENT_OPT = [
  {
    text: 'Gross Revenue',
    value: SEGMENT_GROSS_REVENUE,
  },
  {
    text: 'Net Profit',
    value: SEGMENT_NET_PROFIT,
  },
];

const TABLE_HEAD_MAP = {
  [SEGMENT_GROSS_REVENUE]: {
    bo: {
      keyName: 'bo',
      title: 'BO',
      align: 'left',
      width: '150px',
    },
    studio: {
      keyName: 'studio',
      title: 'Studio',
      align: 'left',
      width: '240px',
    },
    scenario: {
      keyName: 'scenario',
      title: 'Scenario',
      align: 'left',
      width: '150px',
    },
  },
  [SEGMENT_NET_PROFIT]: {
    bo: {
      keyName: 'bo',
      title: 'BO',
      align: 'left',
      width: '150px',
    },
    studio: {
      keyName: 'studio',
      title: 'Studio',
      align: 'left',
      width: '240px',
    },
    scenario: {
      keyName: 'scenario',
      title: 'Scenario',
      align: 'left',
      width: '150px',
    },
  },
};

const RECORDS_MAP: { [keyName: string]: 'grossRevenue' | 'netProfit' } = {
  [SEGMENT_GROSS_REVENUE]: 'grossRevenue',
  [SEGMENT_NET_PROFIT]: 'netProfit',
};

export {
  SEGMENT_OPT,
  SEGMENT_GROSS_REVENUE,
  SEGMENT_NET_PROFIT,
  TABLE_HEAD_MAP,
  RECORDS_MAP,
};
